var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_766_2129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7739 1.96438C14.0458 1.31001 13.1114 0.97188 12.1677 1.00001C10.9961 1.00001 9.81363 1.48125 8.94894 2.37438L8.33332 3.00782L7.71769 2.37438C6.85207 1.48125 5.67081 1.00001 4.49894 1.00001C3.55519 1.00001 2.62175 1.31032 1.86581 1.96438C-0.0760636 3.64532 -0.173251 6.6425 1.57737 8.45187L7.61488 14.6925C7.81457 14.8969 8.07082 15 8.33019 15C8.59057 15 8.85176 14.8979 9.04925 14.6936L15.0836 8.453C16.8396 6.64063 16.7427 3.64375 14.7739 1.96438ZM14.0083 7.40938L8.33332 13.2781L2.65644 7.40938C1.64894 6.36875 1.41019 4.31563 2.84769 3.09844C4.09456 2.01907 5.80363 2.55157 6.64144 3.41625L8.33425 5.16375L10.0268 3.41625C10.8524 2.56407 12.5661 2.01344 13.8205 3.09844C15.2427 4.33125 15.0364 6.34688 14.0083 7.40938Z",
    fill: "#E25297"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_766_2129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.333313)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/LikeIcon.0d268a8a8ecf8042eeea6093f78e0bcd.svg";
export { ForwardRef as ReactComponent };